import {
  VisibilityOffRounded,
  VisibilityRounded,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';

import { FORTA_BLUE, FORTA_ERROR, FORTA_SUCCESS } from '../../../../../../utils/colors';
import { TargetStageStatus } from '../../common/constants/general';

export const STATUS_COLORS = {
  [TargetStageStatus.Initial]: FORTA_BLUE.primary,
  [TargetStageStatus.Progress]: FORTA_SUCCESS,
  [TargetStageStatus.Hold]: FORTA_ERROR,
  [TargetStageStatus.Resume]: FORTA_SUCCESS,
  [TargetStageStatus.Regress]: FORTA_ERROR,
  [TargetStageStatus.Discontinued]: FORTA_ERROR,
};

export const STATUS_ICON_MAP = {
  rounded: { active: VisibilityRounded, inactive: VisibilityOffRounded },
  standard: { active: Visibility, inactive: VisibilityOff },
} as const;
